import { useMemo } from 'react';
import {
  LineChart,
  //BarChart,
  Key,
  BarChartHorizontal,
  Zap,
  Globe,
  FolderTree,
  Battery,
  Home,
  Radio,
  Activity,
} from 'lucide-react';
import { Platform } from '../contexts/PlatformContext';

export interface NavigationItem {
  name: string;
  href: string;
  icon: React.ComponentType<any>;
  permission?: string;
  feature?: string;
  demo?: boolean;
  teaser?: boolean;
  platforms: Platform[];
  limit_visibility?: boolean;
}

// Single source of truth for all navigation items
const allNavigation: NavigationItem[] = [
  {
    name: 'Overview',
    href: '/overview',
    icon: Home,
    platforms: ['user', 'developer'],
  },
  {
    name: 'Forecast',
    href: '/forecast',
    icon: LineChart,
    permission: 'read:forecasts',
    platforms: ['user', 'developer'],
    demo: true,
  },
  {
    name: 'API Keys',
    href: '/api-keys',
    icon: Key,
    permission: 'read:api_keys',
    platforms: ['developer'],
  },
  {
    name: 'Benchmarks',
    href: '/benchmarks',
    icon: BarChartHorizontal,
    permission: 'read:benchmarks',
    platforms: ['developer'],
  },
  // {
  //   name: 'Live Benchmarking',
  //   href: '/live-benchmarking',
  //   icon: BarChart,
  //   permission: 'read:live_benchmarking',
  //   feature: 'live_benchmarking_page',
  //   platforms: ['user'],
  // },
  {
    name: 'Energy Market Aggregates',
    href: '/market-aggregates',
    icon: Zap,
    permission: 'read:market_aggregates',
    feature: 'market_aggregates_page',
    platforms: ['user'],
    demo: true,
  },
  {
    name: 'Map',
    href: '/map',
    icon: Globe,
    feature: 'map_page',
    platforms: ['user'],
  },
  {
    name: 'Power',
    href: '/power',
    icon: Battery,
    feature: 'power_forecast_v0',
    platforms: ['user'],
    permission: 'read:power_forecast_v0',
  },
  {
    name: 'Stations',
    href: '/stations',
    icon: Radio,
    platforms: ['user'],
    teaser: true, // This adds the beta banner
  },
  {
    name: 'Files',
    href: '/browse',
    icon: FolderTree,
    permission: 'read:files',
    feature: 'file_browser',
    platforms: ['developer'],
    limit_visibility: true,
  },
  {
    name: 'Dissemination Status',
    href: '/dissemination-status',
    icon: Activity,
    platforms: ['user', 'developer'],
  },
];

export function useNavigation(platform: Platform): NavigationItem[] {
  return useMemo(() => {
    return allNavigation.filter((item) => item.platforms.includes(platform));
  }, [platform]);
}
